import { SERVER_IS_NORWAY } from './config';

export const timeLocale = () => {
    return SERVER_IS_NORWAY ? 'nb' : 'en';
};
export const serverTimeMonthDay = () => {
    return !SERVER_IS_NORWAY;
};

export const serverTimeFormat = (skipYear = false, withTime = false) => {
    if (skipYear) {
        return SERVER_IS_NORWAY ? 'DD.MM' : 'MM/DD';
    }
    if (withTime) {
        return SERVER_IS_NORWAY ? 'D MMMM YYYY, HH:mm' : 'D MMMM YYYY, hh:mm a';
    }
    return SERVER_IS_NORWAY ? 'DD.MM.YYYY' : 'MM/DD/YYYY';
};

export const serverIsAmPmTimeFormat = () => {
    return !SERVER_IS_NORWAY;
};

export const serverValidation = (code) => {
    if (code === 'phone') {
        return /^(\+|\d)( ?\d){6,13}$/;
    }
    if (code === 'social') {
        return SERVER_IS_NORWAY ? /^(\d{11})$/ : /.*/;
    }
    if (code === 'zip') {
        return /^\d{4,5}$/;
    }
    if (code === 'email') {
        return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    }
    if (code === 'tax') {
        return /^\d{9}$/;
    }
    if (code === 'bank_account_number') {
        return /^(\d{11,20})$/
    }
    return /.*/;
};

export const defaultLanguage = () => {
    return SERVER_IS_NORWAY ? 'Norsk' : 'English';
};

export const moneySymbol = () => {
    return 'nok'
};

export const hourSymbol = () => {
    return SERVER_IS_NORWAY ? 't' : 'h';
};